<template>
  <div id="bookautocomplete2" class="all-autocom w-100">
    <div class="d-flex justify-content-center align-items-center mb-2">
      <input type="text" placeholder="ค้นหาหนังสือ..." v-model="query" v-on:keyup="getData" autocomplete="off" class="form-control input-autocom xd-text w-regular s-14"  
       style="height:1.75rem !important;" >
       <b-icon icon="search" class="ml-2"></b-icon>
    </div>
    <!-- <div class="table-cell" style="padding:5px!important;width:100%">
      <input type="text" placeholder="ค้นหาหนังสือ..." v-model="query" v-on:keyup="getData" autocomplete="off" class="form-control table-cell input-autocom"  
       style="height:25px !important;" >
    </div>
  <div class="table-cell">
    <b-icon icon="search" class="table-cell"></b-icon>
  </div> -->
      
      <div class="panel-footer" v-if="search_data.length && showdropdown" style="position:absolute !important;z-index:800;">
        <ul class="list-group">
          <a @click="getlink(data1.id)" class="list-group-item list-group-item-autocom" v-for="data1 in search_data" :key="data1.id">{{ data1.name }}</a>
        </ul>
      </div>
    </div>
</template>
<style lang="scss">
.table-cell{
  display: table-cell;
  /*padding: 5px;*/
}
.list-group-item-autocom{
  color: black !important;
  size:16px !important;
  font-weight: unset !important;
  padding: .75rem 1.25rem !important;
  background-color: #fff !important;
  border: 1px solid rgba(0,0,0,.125) !important;
}
.input-autocom{
  width:180px !important
}
@media screen and (max-width: 960px) {
  .input-autocom {
    width:100% !important
    /* Add other properties here */
  }
}
.all-autocom{
  padding:unset !important;
}
@media screen and (max-width: 960px) {
  .all-autocom {
    padding:5px!important;
    padding-right:10px!important;
  }
}
</style>
<script>
import axios from "axios";
export default {
  name: "BookAutoCompleteForMobile",
  props: {
    display: Boolean,
  },
  data() {
    return {
        query:"",
        search_data:[],
        showdropdown:false
    };
  },
  methods:{
      getData(){
        this.search_data = [];
        this.axios
        .get("/Product/BookAutoComplete?txt=" + this.query)
        .then(res => {
          this.search_data = res.data;
        });
      },
      getName(name){
        this.query = name;
        this.search_data = [];
      },
      getlink(id){
          location.replace("/ProductDetail/" + id);
          //return "/ProductDetail/" + id;
      },
      show(){
          this.showdropdown = true;
      },
      hide(){
          this.showdropdown = false;
      },
      AddEvent(form){
        form.addEventListener("focusin", (event) => {
            this.showdropdown = true;
        });
        form.addEventListener("focusout", (event) => {
            //setTimeout(this.hide(), 10000);
            setTimeout(() => this.showdropdown = false,1000);
        });
      }
    },
    mounted(){
      const form = document.getElementById("bookautocomplete2");
      document.addEventListener("deviceready",this.AddEvent(form), false);
    }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list-group-item-autocom{
  color: black !important;
  size:16px !important;
  font-weight: unset !important;
}
#customautocomplete{
    transition: width 2s;
    overflow-x: hidden;
}
</style>
